import { render, staticRenderFns } from "./SelectSourceDestination.vue?vue&type=template&id=40a5f033"
import script from "./SelectSourceDestination.vue?vue&type=script&lang=js"
export * from "./SelectSourceDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports